import { action } from "typesafe-actions";
import { AuthorizationActionTypes } from "./types";

// 获取登陆用户信息
export const fetchUserInfo = () => action (
  AuthorizationActionTypes.FETCH_USER_INFO
);

export const fetchUserInfoFinish = (data: any) => action (
  AuthorizationActionTypes.FETCH_USER_INFO_FINISH,
  data
);

export const fetchUserInfoError = () => action(
  AuthorizationActionTypes.FETCH_USER_INFO_ERROR,
);

// 获取系统基础信息
export const fetchSysParam = (data: any) => action(
  AuthorizationActionTypes.FETCH_SYS_PARAM,
  data
)

export const fetchSysParamFinish = (data: any) => action(
  AuthorizationActionTypes.FETCH_SYS_PARAM_FINISH,
  data
)



// WEBPACK FOOTER //
// ./src/store/authorization/actions.ts